import { useQuery } from '@tanstack/react-query';
import api from '../../services';
import { ZuulAuditEvent } from './types.ts';
import moment from 'moment-timezone';

export const useZuulAuditEvents = (route: string, from: string, enabled: boolean = true) => useQuery<ZuulAuditEvent[]>({
  queryKey: ['zuulAuditEvents', route, from],
  queryFn: async (): Promise<ZuulAuditEvent[]> => {
    const toEST = moment(new Date()).tz('America/New_York').format('YYYY-MM-DDTHH:mm:ss');

    const res = await api.get(`events?route=${route}&from=${from}&to=${toEST}`);
    return res.data;
  },
  enabled,
});
